import { UIData } from '../../hooks/stores/uiStore';

export interface HistoryState {
  launcherConfigJSON: string;
}

interface HistoryUtilsDependencies {
  UIData: UIData;
  setUIData: (data: Partial<UIData>) => void;
  isHistoryActionInProgress: React.MutableRefObject<boolean>;
  exportConfig: () => string;
  importConfig: (configJSON: string, quietConversion?: boolean) => void;
}

export function createHistoryUtils({
  UIData,
  setUIData,
  isHistoryActionInProgress,
  exportConfig,
  importConfig,
}: HistoryUtilsDependencies) {
  const historySave = () => {
    if (isHistoryActionInProgress.current) {
      isHistoryActionInProgress.current = false;
      return;
    }

    const lastState = UIData.historyUndoStack[UIData.historyUndoStack.length - 1];
    const currentState = {
      launcherConfigJSON: exportConfig(),
    };

    if (JSON.stringify(lastState) === JSON.stringify(currentState)) return;

    setUIData({
      historyUndoStack: [...UIData.historyUndoStack, currentState],
      historyRedoStack: [],
    });

    if (UIData.historyUndoStack.length >= 1000) {
      setUIData({
        historyUndoStack: UIData.historyUndoStack.slice(1),
      });
    }
  };

  const historyUndo = () => {
    const lastState = UIData.historyUndoStack[UIData.historyUndoStack.length - 1];
    const preLastState = UIData.historyUndoStack[UIData.historyUndoStack.length - 2];

    if (preLastState) {
      isHistoryActionInProgress.current = true;
      importConfig(preLastState.launcherConfigJSON, true);
      setUIData({
        historyUndoStack: UIData.historyUndoStack.slice(0, -1),
        historyRedoStack: [...UIData.historyRedoStack, lastState],
      });
    }
  };

  const historyRedo = () => {
    const lastState = UIData.historyRedoStack[UIData.historyRedoStack.length - 1];

    if (lastState) {
      isHistoryActionInProgress.current = true;
      importConfig(lastState.launcherConfigJSON, true);
      setUIData({
        historyUndoStack: [...UIData.historyUndoStack, lastState],
        historyRedoStack: UIData.historyRedoStack.slice(0, -1),
      });
    }
  };

  return {
    historySave,
    historyUndo,
    historyRedo,
  };
} 